export default {"src":"/_next/static/media/instagram.47a8c9c7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};